import { useQuery } from '@tanstack/react-query';
import { ResourceType } from 'libs.library_manager';
import { ApiClientService, useApiClient } from 'libs.react_internal';
/**
 * Hook to fetch library resource details by ID and type.
 *
 * @param id - The resource ID to fetch. If undefined, the query will be disabled.
 * @param type - The resource type (defaults to ACTIVITY).
 * @param withUrl - Whether to include URL in the request params.
 * @returns React Query result with library resource details.
 *
 * @public
 */
export function useLibraryDetails(id, type = ResourceType.ACTIVITY, withUrl = false) {
    const { get } = useApiClient(ApiClientService.LIBRARY);
    return useQuery({
        queryKey: ['library', 'details', id],
        queryFn: () => {
            const params = withUrl ? { withUrl: true } : {};
            return get(`v1/${type}/${id}`, { params });
        },
        enabled: !!id,
        retry: false,
    });
}
//# sourceMappingURL=use_library_details.hook.js.map